import styled, { css } from "styled-components";
import queries, { minQuery, devices } from "utils/responsivenessHelper";
import { menuWidth, headerHeight } from "constants/layout";
import colours from "assets/colours";
import zIndex from "constants/zIndex";

const Container = styled.div`
  ${({ mobile, navOpen }) => {
    if (!mobile && navOpen) {
      return css`
        padding-left: ${menuWidth};
      `;
    } else if (mobile && navOpen) {
      return css`
        transition: all 0.5s ease;
        padding-right: 250px;
        ${minQuery.both(
          {
            paddingRight: menuWidth,
          },
          null,
          devices.iPad
        )}
      `;
    }
  }}
`;

const MainWrapper = styled.div`
  width: 100%;
  position: absolute;
  margin-top: ${headerHeight};
  background: ${colours.zltoGreyBackground};
  overflow-y: auto;
  overflow-x: hidden;

  ${queries.both({
    marginTop: "110px",
  })}

  ${({ mobile, navOpen }) => {
    if (!mobile && navOpen) {
      return css`
        width: calc(100% - ${menuWidth});
      `;
    }
  }}
`;

const Main = styled.div`
  width: 100%;
  min-height: calc(100vh - 110px);
  display: flex;
  flex-direction: column;
  padding: 20px;
  z-index: ${zIndex.main};
  position: relative;

  ${queries.both({
    padding: "0px 5px",
  })};
`;

const UserInfoWrapper = styled.div`
  background: ${colours.white};
  box-shadow: 10px 10px 54px rgba(108, 109, 133, 0.11);
  width: 100%;
  position: relative;
  z-index: ${zIndex.userInfo};
`;

const Graphic = styled.img`
  max-width: 35%;
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: ${zIndex.graphic};

  ${queries.both({ display: "none" }, devices.mobile)}
  ${queries.landscape({ display: "block" }, devices.iPadPro)}
`;

export { Container, MainWrapper, Main, UserInfoWrapper, Graphic };
